module.exports = __webpack_public_path__ + "img/create_instance_check.bdeb8bc8.svg";